<!--  -->
<template>
  <div class="literature-details">
    <div class="literature-title" v-html="literatureInfo.r_title">
      <!-- {{()}} -->
    </div>
    <div class="literature-details-info">
      <div class="literature-general-info">
        <h3 class="general-info-title">General Info</h3>
        <div class="general-info-container">
          <dl>
            <dt>Literature type</dt>
            <dd v-html="literatureInfo.r_literature_type"></dd>
          </dl>
          <dl>
            <dt>Title</dt>
            <dd v-html="literatureInfo.r_title"></dd>
          </dl>
          <dl>
            <dt>Volume</dt>
            <dd v-html="literatureInfo.r_volume"></dd>
          </dl>
          <dl>
            <dt>Issue</dt>
            <dd v-html="literatureInfo.r_issue"></dd>
          </dl>
          <dl>
            <dt>Page number</dt>
            <dd>{{literatureInfo.r_pages}}</dd>
          </dl>
          <dl>
            <dt>Doi</dt>
            <dd v-html="literatureInfo.r_doi"></dd>
          </dl>
          <dl>
            <dt>Author</dt>
            <dd>{{innerHTML(literatureInfo.r_author)}} {{innerHTML(literatureInfo.r_joint_author)}}</dd>
          </dl>
          <dl>
            <dt>Year</dt>
            <dd v-html="literatureInfo.r_year"></dd>
          </dl>
          <dl>
            <dt>Journal</dt>
            <dd v-html="literatureInfo.r_journal"></dd>
          </dl>
          <dl>
            <dt>Created time</dt>
            <dd v-html="literatureInfo.r_time"></dd>
          </dl>
          <dl>
            <dt>Contributor</dt>
            <dd v-html="literatureInfo.admin_en_name"></dd>
          </dl>
          <dl>
            <dt>Last edit time</dt>
            <dd v-html="literatureInfo.r_last_edit_time"></dd>
          </dl>
        </div>
      </div>
      <div class="literature-related-specimens">
        <h3 class="general-info-title">Related specimens</h3>
        <div v-for="(item,_index) in relatedList" :key="_index">
          <div class="crumb-list">
            <span v-for="(crumb,index) in item.crumbList" :key="crumb.s_id">
              {{innerHTML(crumb.s_en_name)}} <b v-if="index != item.crumbList.length-1">></b>
            </span>
          </div>
          <div class="specimens-list">
            <div v-for="fossil in item.fossilList" :key="fossil.fossil_id">
              <router-link :to="`/fossil_details/${fossil.fossil_id}`">
                {{ innerHTML(fossil.f_specimen_number)}}
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getLiteratureDetails } from "@/api/index";
import { deepBoneDomin, ossImage } from "@/common.js";
import { mixins } from "@/mixins/index.js";
export default {
  mixins: [mixins],
  name: "literature",
  components: {},
  data() {
    return {
      defaultImgHeader: deepBoneDomin,
      ossImage: ossImage,
      fossilList: [],
      crumbList: [],
      relatedList: [],
      literatureInfo: {
        list: [
          {
            admin_en_name: "Pan Zhaohui",
            admin_id: 2,
            admin_name: "潘照晖",
            connected_time: "2017-03-06 18:19:55",
            f_path: "0-63836-2-3-3291-6-10-",
            crumb: [],
            fossilList: [],
          },
        ],
        admin_en_name: "Pan Zhaohui",
        admin_id: 2,
        admin_name: "潘照晖",
        r_author: "Zhang, G.R.",
        r_doi: "",
        r_fossil_num: 8,
        r_is_show: 0,
        r_issue: "3",
        r_joint_author: "Young, G.",
        r_journal: "Alcheringa",
        r_keywords:
          "Placodermi; Antiarehi; Bothriolepidoidei; Luqucmolepia Ben. nov.; Early Devonian; South China; cladistlc analysis",
        r_last_edit_time: "4-15-2020",
        r_literature_type: "Journal Article",
        r_pages: "219-240",
        r_pdf_path: "literature/3/reference_id_3_20180505164246743.pdf",
        r_taxa_num: 1,
        r_time: "3-30-2017",
        r_title:
          "A new antiarch (placoderm fish) from the Early Devonian of South China",
        r_typeofarticle: "",
        r_volume: "16",
        r_year: 1992,
      },
      routerName:'',
      tibetName: "TibetPlateau",
    };
  },
  //生命周期 - 创建完成（访问当前this实例）
  created() {},
  //生命周期 - 挂载完成（访问DOM元素）
  mounted() {
    this.routerName = this.$route.name;
    let id = this.$route.params.r_id;
    this.getLiteratureDetails(id);
  },
  methods: {
    getLiteratureDetails(id) {
      getLiteratureDetails(id).then((res) => {
        let data = res.data?.data || {};
        this.literatureInfo = data;
        for (let key in this.literatureInfo) {
          this.literatureInfo[key] = data[key];
        }
        this.initList(id, data.list);
      });
    },
    initList(id, list) {
      let relatedList = [];
      list.forEach((_) => {
        let crumbList = this.initSpeciesPath(id, _.f_path, _.crumb);
        let fossilList = _.fossilList;

        relatedList.push({
          crumbList,
          fossilList,
        });
      });

      this.$set(this, "relatedList", relatedList);
    },
    initSpeciesPath(self_path, f_path, speciesPath) {
      let paths = f_path.split("-");
      let _speciesPath = [];
      paths.forEach((path) => {
        let species = speciesPath.filter((el) => el.s_id == path);
        if (species.length) {
          _speciesPath.push(species[0]);
        }
      });
      let self_species = speciesPath.filter((el) => el.s_id == self_path);
      if (self_species.length) {
        _speciesPath.push(self_species[0]);
      }
      return _speciesPath;
      //   this.$set(this, "speciesPath", _speciesPath);
    },
    // initRelatedListPath(relatedList) {
    //     let crumbList = relatedList.crumbList
    //   console.log(relatedList);
    // },
  },
};
</script>
<style >
.literature-general-info {
  width: 64%;
  margin-right: 2%;
  background: #ffffff;
  border-radius: 4px;
  padding: 20px;
}
.literature-related-specimens {
  width: 34%;
  max-width: 455px;
  padding: 20px;
  background: white;
}

.general-info-title {
  font-family: Roboto;
  font-style: normal;
  font-weight: 600;
  font-size: 24px;
  line-height: 28px;
  color: #484d63;
  margin-bottom: 32px;
}
.general-info-container {
}
.general-info-container dl {
  line-height: 20px;
  padding: 12px 0;
  border-bottom: 2px solid #efefef;
  color: #484d63;
}
.general-info-container dl dt {
  width: 180px;
}
.general-info-container dd {
  display: inline-block;
  width: calc(100% - 180px);
}
.crumb-list {
  margin-bottom: 12px;
}
.crumb-list span {
  font-size: 16px;
  line-height: 18px;
  color: #c4c4c4;
}
.specimens-list div {
  margin-bottom: 12px;
}
.specimens-list a {
  font-size: 16px;
  line-height: 19px;

  color: #72c2c9;
}
</style>
